import { Flex, Input, InputProps } from '@chakra-ui/react';
import { format } from 'date-fns';
import React from 'react';
import { BsCalendar } from 'react-icons/bs';
import PlaceholderOverlay from '../Shared/PlaceholderOverlay';
import IconOverlay from '../Shared/IconOverlay';
import { isFirefox, isIOS } from 'react-device-detect';

export type DateInputProps = {
	value?: string;
	onChange?: (props: {
		value: string;
		event: React.ChangeEvent<HTMLInputElement>;
	}) => void;
	minDate?: string;
	maxDate?: string;
	dateFormat?: string;
	timeFormat?: string;
	invalidField?: string;
} & Omit<InputProps, 'value' | 'onChange'>;

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
	(props, ref) => {
		const { name, value, onChange, ...rest } = props;
		const [inputValue, setInputValue] = React.useState(value || '');
		const inputRef = React.useRef<HTMLInputElement | null>(null);

		React.useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

		const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
			if (isFirefox) {
				e.currentTarget.showPicker();
			}
		};

		const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
			if (e.target.value === '') {
				setInputValue('');
			}
		};

		const handleChange = React.useCallback(
			(event: React.ChangeEvent<HTMLInputElement>) => {
				onChange?.({ value: event.target.value, event });
			},
			[onChange]
		);

		React.useEffect(() => {
			setInputValue(value || '');
		}, [value]);

		return (
			<>
				<Flex position="relative" alignItems="center" bg="white" h="51px">
					{inputValue === '' && (
						<PlaceholderOverlay
							label="Selecione a data"
							onClick={e => {
								const input = e.currentTarget.parentElement
									?.lastChild as HTMLInputElement | null;
								if (input) {
									input.value = '';
									input.focus?.();
									input.showPicker?.();
								}
							}}
						/>
					)}
					{(!isFirefox || (isFirefox && isIOS)) && (
						<IconOverlay
							icon={<BsCalendar size={'1rem'} z={10} />}
							bg="white"
							h="90%"
							w="11%"
							zIndex="30"
							onClick={e => {
								const input = e.currentTarget.parentElement
									?.lastChild as HTMLInputElement | null;
								console.log(input);
								if (input) {
									input.value = '';
									input.focus?.();
									input.showPicker?.();
								}
							}}
							left={isFirefox ? '' : '13px'}
							right={'18px'}
						/>
					)}
					<Input
						ref={inputRef}
						name={`${name}-date`}
						title="Data"
						type={'date'}
						h="full"
						value={inputValue}
						sx={{
							'&::selection': {
								background: 'blue',
								color: 'white',
							},
							'&::-moz-selection': {
								background: 'blue',
								color: 'white',
							},
						}}
						onClick={handleClick}
						onChange={handleChange}
						onBlurCapture={handleBlur}
						letterSpacing="-.014rem"
						color="#000000"
						min={format(new Date(), 'yyyy-MM-dd')}
						flex={1}
						bg="transparent"
						zIndex="2"
						cursor={'default'}
						fontSize={{ base: '12px', sm: 'inherit' }}
						border="1px solid #666"
						_focus={{ border: '1px solid #666' }}
						_hover={{ border: '1px solid #666' }}
						_invalid={{ border: '2px solid red' }}
						_selection={{ color: 'white', bg: 'blue' }}
						pl={isFirefox ? '15px' : '37px'}
						pr={isFirefox ? '-1rem' : ''}
						_placeholder={{
							color: { base: '#222', lg: '#666' },
						}}
						{...rest}
					/>
				</Flex>
			</>
		);
	}
);

export default DateInput;
